import React, { useRef } from 'react';
import { ActiveCampaignForm } from './components/ActiveCampaignForm';
import { WhatYouGetSection } from './components/WhatYouGetSection';
export function App() {
  const formRef = useRef(null);
  return <div className="min-h-screen w-full bg-gray-900" data-id="element-0">
      {/* Above the fold section */}
      <div className="w-full bg-gray-900 py-12 px-4 sm:px-6 sm:py-16 lg:px-8" data-id="element-1">
        <div className="max-w-3xl mx-auto" data-id="element-2">
          <div ref={formRef} className="text-center mb-8" data-id="element-3">
            <p className="text-base sm:text-lg uppercase tracking-wider font-semibold text-[#8AE234] mb-0.5" data-id="element-4">
              Isaiah's private newsletter
            </p>
            <h1 className="text-3xl sm:text-3xl md:text-4xl font-extrabold text-white tracking-tight mb-6 leading-tight" data-id="element-5">
              Daily Insights On How I Went From{' '}
              <span className="text-[#8AE234] underline" data-id="element-6">
                Homeless In Miami To Making 20k/Mo
              </span>{' '}
              With AI Copywriting Before It Was "Cool"
            </h1>
          </div>
          {/* Opt-in form card */}
          <div className="bg-gray-900 rounded-lg shadow-lg overflow-hidden mb-4 border border-gray-800" data-id="element-7">
            <div className="p-3 sm:p-5" data-id="element-8">
              <ActiveCampaignForm data-id="element-9" />
              <p className="mt-4 text-center text-sm text-gray-400" data-id="element-10">
                I hate spam as much as you do. I'll never sell your information.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Below the fold content */}
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-8" data-id="element-11">
        <WhatYouGetSection data-id="element-12" />
      </div>
    </div>;
}